<div class="compact-popup-container" [class.show-content]="showContent" (click)="$event.stopPropagation()">
  @for (action of actions; track action) {
    @if (action.Id !== suggestedAction?.Id && !action.Hidden) {
      <div class="action-btn"
        (click)="onBtnClick(action)">
        <img [src]="actionHelper.getActionIconUrl(action.Name)"
          alt="icon"
          matTooltip="{{action?.Label}}" matTooltipPosition="below" matTooltipClass='tooltip-style'
          >
        <div class="text">{{action.Label}}</div>
        @if (action.Name.includes('_EXT')) {
          <span class="external" fiTranslation="External"></span>
        }
      </div>
    }
  }

  @if (isDuplicateLead) {
    <div class="action-btn" (click)="onDuplicateBtnClick()">
      <img
        src="/assets/icons/duplicate.svg"
        alt="icon"
        class="duplicate"
        matTooltip="{{duplicate.textContent}}"
        matTooltipPosition="below"
        matTooltipClass='tooltip-style'
        >
      <div class="text" #duplicate fiTranslation="ALT_TEXT_DUPLICATE_CHECK"></div>
    </div>
  }

  <div class="action-btn" (click)="emitOpenDetail($event.ctrlKey)">
    <img
      src="/assets/icons/new/info-circle.svg"
      alt="icon"
      matTooltip="{{open.textContent}}"
      matTooltipPosition="below"
      matTooltipClass='tooltip-style'
      >
    <div class="text" #open fiTranslation="REQUEST_OVERVIEW_DETAIL"></div>
  </div>

  <div class="action-btn" (click)="read ? emitMarkAsUnread() : emitMarkAsRead()">
    <img
      src="/assets/icons/new/eye.svg"
      alt="icon"
      matTooltip="{{read ? unread.textContent : readText.textContent}}"
      matTooltipPosition="below"
      matTooltipClass='tooltip-style'
      >
    <div class="text" [class.hidden]="read" #readText fiTranslation="REQUEST_OVERVIEW_BULK_MARK_AS_READ"></div>
    <div class="text" [class.hidden]="!read" #unread fiTranslation="REQUEST_OVERVIEW_DETAIL_UNREAD"></div>
  </div>

  @for (action of actions; track action) {
    @if (action.Id === suggestedAction?.Id) {
      <div class="action-btn suggested"
        (click)="onBtnClick(action)">
        <img [src]="actionHelper.getActionIconUrl(action.Name, false)"
          alt="icon"
          matTooltip="{{action?.Label}}" matTooltipPosition="below" matTooltipClass='tooltip-style'
          >
        <div class="text">{{action.Label}}</div>
      </div>
    }
  }

</div>
